/**
 *
 * ReportOperation
 *
 */
import { memo } from 'react';

import { Route, Routes } from 'react-router-dom';

import Create from './pages/create';
import List from './pages/list';

interface Props {}

// eslint-disable-next-line react/display-name
export const ReportOperation = memo((props: Props) => {
  return (
    <>
      <div>
        <Routes>
          <Route index element={<List />} />
          <Route path="create" element={<Create />} />
        </Routes>
      </div>
    </>
  );
});
